import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";

export const INSURANCE_SERVICE_LOG_RETRIEVED = gql`
  subscription insuranceServiceLogRetrieved {
    insuranceServiceLogRetrieved {
      insuranceServiceLogResult {
        requestUID
        details {
          dateRequestSent
          requestContent
          dateResponseReceived
          responseContent
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const INSURANCE_SERVICE_LOGS_RETRIEVED = gql`
  subscription insuranceServiceLogsRetrieved {
    insuranceServiceLogsRetrieved {
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
